const initialState = localStorage.getItem("pitch") ?? 1;

function pitchReducer(state = initialState, action) {
  switch (action.type) {
    case "pitch/update":
      return action.payload;
    default:
      return state;
  }
}

export default pitchReducer;
